import { render, staticRenderFns } from "./StoreGiftListComponent.vue?vue&type=template&id=6bf2f665&scoped=true"
import script from "./StoreGiftListComponent.vue?vue&type=script&lang=js"
export * from "./StoreGiftListComponent.vue?vue&type=script&lang=js"
import style0 from "./StoreGiftListComponent.vue?vue&type=style&index=0&id=6bf2f665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf2f665",
  null
  
)

export default component.exports